import React, { forwardRef, useEffect, useState } from 'react';

import DatePicker, { registerLocale }  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import es from 'date-fns/locale/es';
import { Tooltip } from '../utils/Tooltip';
import { formatDate } from '../../../utils/utils';
import { parse, isValid } from 'date-fns';
registerLocale('es', es)

export const DatePickerABX = ({
    date,
    setDate,
    endDate,
    setEndDate,
    styles,
    classNameInput,
    keyDate,
    keyEndDate,
    disabled,
    maxDate,
    minDate,
    titleIcono,
    ocultarIcono,
    dobleFecha,
}) => {

    const [ fechaInterna, setFechaInterna ] = useState(null);
    
    const cambiarFecha = (fecha) => {
        keyDate ? setDate(keyDate, formatDate(fecha)) : setDate(formatDate(fecha))
        setFechaInterna(transformarFecha(date))
        dobleFecha && setEndDate(keyEndDate ? (keyEndDate, formatDate(fecha)) : formatDate(fecha))
    }

    const transformarFecha = (inputDate) => {
        if (!inputDate) return null;

        if (typeof inputDate === 'string') {
            const parsedDate = parse(inputDate, 'dd/MM/yyyy', new Date());
            return isValid(parsedDate) ? parsedDate : null;
        }

        // Si ya es un objeto Date válido, no se hace nada
        if (inputDate instanceof Date && isValid(inputDate)) {
            return inputDate;
        }

        return null; // En caso de que no sea válido
    };

    useEffect(() => {
        setFechaInterna(transformarFecha(date));
    },[date]);

    const DateInput = forwardRef(({ value, onClick }, ref) => (
        <input 
            onClick={onClick}
            ref={ref}
            className={` ${classNameInput ? classNameInput : 'bg-zinc-800 '} text-center text-white h-[30px] 
            rounded px-4 w-[100px] text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 lg:w-[70px] lg:px-1`}
            defaultValue={value}
            style={styles}
            readOnly
            placeholder="Ingrese la fecha..."
        />
    ));

    return (
        <section className={`grid ${!ocultarIcono ? 'grid-cols-[minmax(0,2fr)_minmax(0,8fr)] gap-2' : ''} items-center lg:w-auto lg:gap-1`}>
            {
                !ocultarIcono ? 
                    <>
                        <i
                            className={`fa fa-regular fa-calendar-days`}
                            data-tip={titleIcono||'date'}
                            data-for={titleIcono||'date'}
                        ></i>
                        <Tooltip id={titleIcono||'date'}>{titleIcono||'Fecha'}</Tooltip>
                    </>
                : ''
            }
            <DatePicker
                locale="es" 
                selected={fechaInterna}
                onChange={cambiarFecha}
                customInput={<DateInput/>} 
                dateFormat="dd/MM/yyyy"
                maxDate={maxDate ? transformarFecha(maxDate) : undefined}
                minDate={minDate? transformarFecha(minDate) : undefined}
                disabled={disabled ? true : false}
                showYearDropdown
                showMonthDropdown
                popperClassName="custom-popper-datepicker"
            ></DatePicker>
        </section>
    )
}